import { nanoid } from 'nanoid';
import { cloneDeep } from 'lodash-es';
import { DEFAULT_LONG_MEMORY } from '@/constants/agentTypes';

export function formatUserMemoryVariableRows(list) {
  if (!Array.isArray(list)) return [];
  return list.map(i => {
    let { type } = i;
    if (type && typeof type === 'string') {
      type = type.includes('<')
        ? type.replace('>', '').split('<')
        : [type];
    }
    return {
      ...i,
      type,
      id: i.id || nanoid()
    };
  });
}

const LONG_TERM_MEMORY_DEFAULTS = {
  delay_minute: 5,
  is_long_term_memory_enable: false,
  long_term_memory_count: 10,
  long_term_memory_robots: [],
  long_term_memory_robots_name: [],
  long_term_memory_scope: 1,
  long_term_memory_synchronous: false,
  user_profile_custom_content: [],
  user_memory_points_prompt: '',
  user_memory_points_count: 5,
  user_memory_points_collect_type: 1,
  user_memory_variable_content: [],
  is_user_profile_custom: false,
  is_user_memory_points_custom: false,
  is_user_memory_variable: false
};

export const LONG_TERM_MEMORY_CONFIG_KEYS = Object.keys(LONG_TERM_MEMORY_DEFAULTS);

/**
 */
export function stripLegacyLongTermKeysFromAgentConfigRoot(config) {
  if (!config || typeof config !== 'object') return;
  for (const key of LONG_TERM_MEMORY_CONFIG_KEYS) {
    if (Object.prototype.hasOwnProperty.call(config, key)) {
      delete config[key];
    }
  }
}

/**
 */
export function mergeLongTermMemoryFromConfig(config) {
  if (config == null) {
    return mergeLongTermMemoryFromConfig({});
  }

  const nested =
    config.long_term_memory_config &&
    typeof config.long_term_memory_config === 'object' &&
    !Array.isArray(config.long_term_memory_config)
      ? config.long_term_memory_config
      : null;

  const legacyFromRoot = {};
  for (const key of LONG_TERM_MEMORY_CONFIG_KEYS) {
    if (Object.prototype.hasOwnProperty.call(config, key)) {
      legacyFromRoot[key] = config[key];
    }
  }

  const source = {
    ...legacyFromRoot,
    ...(nested ? nested : {})
  };

  const merged = { ...LONG_TERM_MEMORY_DEFAULTS };
  for (const key of LONG_TERM_MEMORY_CONFIG_KEYS) {
    if (key === 'user_profile_custom_content' || key === 'user_memory_variable_content') {
      continue;
    }
    if (source[key] !== undefined && source[key] !== null) {
      merged[key] = source[key];
    }
  }
  const rawProfile = source.user_profile_custom_content;
  const isProfileArray = Array.isArray(rawProfile);
  const isEmptyProfile = isProfileArray && rawProfile.length === 0;
  const userClearedCustomProfile =
    source.is_user_profile_custom === 1 ||
    source.is_user_profile_custom === true ||
    source.is_user_profile_custom === '1';
  const profileFromDefaults =
    !isProfileArray || (isEmptyProfile && !userClearedCustomProfile);

  merged.user_profile_custom_content = profileFromDefaults
    ? cloneDeep(DEFAULT_LONG_MEMORY.user_profile_custom_content || []).map(item => ({
        ...item,
        id: item.id || nanoid()
      }))
    : rawProfile.map(item => ({
        ...item,
        id: item.id || nanoid()
      }));
  merged.user_memory_variable_content = Array.isArray(
    source.user_memory_variable_content
  )
    ? formatUserMemoryVariableRows(source.user_memory_variable_content)
    : formatUserMemoryVariableRows(
        cloneDeep(DEFAULT_LONG_MEMORY.user_memory_variable_content || [])
      );
  merged.is_user_profile_custom =
    source.is_user_profile_custom != null
      ? source.is_user_profile_custom
      : profileFromDefaults && merged.user_profile_custom_content.length > 0
        ? 1
        : merged.user_profile_custom_content.length > 0;
  merged.is_user_memory_points_custom =
    source.is_user_memory_points_custom ??
    !!(
      merged.user_memory_points_prompt &&
      String(merged.user_memory_points_prompt).trim() !== ''
    );
  merged.is_user_memory_variable =
    source.is_user_memory_variable ?? merged.user_memory_variable_content.length > 0;
  return merged;
}
